const WIDGET_AGENT_DATA_KEY = "widget_agent_data";
const USER_KEY = "user";

let mountSessionToken: string | null = null;

/** Override opcional desde CotizadorWidget.mount({ token }). */
export const setMountSessionToken = (token: string | null | undefined): void => {
  const trimmed = typeof token === "string" ? token.trim() : "";
  mountSessionToken = trimmed || null;
};

export const getMountSessionToken = (): string | null => mountSessionToken;

const readTokenFromStorage = (key: string): string | null => {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    const token = parsed.Token;
    if (typeof token === "string" && token.trim()) return token.trim();
    return null;
  } catch {
    return null;
  }
};

/**
 * Token de sesión para PDF de cotización.
 * Prioridad: mount override → widget_agent_data → user (SSO/portal).
 */
export const getSessionToken = (): string | null => {
  if (mountSessionToken) return mountSessionToken;
  return readTokenFromStorage(WIDGET_AGENT_DATA_KEY) ?? readTokenFromStorage(USER_KEY);
};
